<template>
  <div>
    <page-title icon="fas fa-table" main="Cadastro" sub="Setores"
      :help="true" titleHelp="Ajuda - Setores"
      content="Responsável por listar setores e suas devidas regiões.
        Para criação pressione o botão no canto superior direito 'Novo Produto Preferencial'.
        Para alteração de um produto preferencial basta ir com o mouse em ações e clicar em Editar."
      >
      <template v-slot:actions>
        <el-tooltip 
          class="box-item" 
          effect="dark"
          content="Cadastrar um novo setor"
          placement="top"
        >
          <base-button @click="register" type="neutral" class="ml-3" size="sm">Cadastro</base-button>
        </el-tooltip>
      </template>
    </page-title>
    <modal :show.sync="modals.modal0" id="cadastrar-seções" size="lg">
      <template slot="header"> 
        <h5 class="modal-title" id="exampleModalLabel">{{ this.sector_id ? 'Editar Setor' : 'Cadastrar Setores'}}</h5>
      </template>
      <validation-observer ref="observer">
        <form role="form">
          <div class="row">
            <div class="col-10 col-sm-10 col-md-12">
              <div v-if="formOptions.existingBranch">
                <div class="row">
                  <div class="col-12 col-sm-12 col-md-12">
                    <ValidationProvider vid="anosafra" name="anosafra" rules="required" v-slot="{ errors }">
                      <base-input :required="true" :error="errors[0]">
                        <anosafra-multiselect
                          v-model="formData.branch.anosafras"
                          :multiple="true"
                          placeholder="Escolha um Ano Safra"
                          label="Ano Safra"
                          :required="true"
                          :limit="1"
                          :limit-text="limitText"
                        />
                      </base-input>
                    </ValidationProvider>
                  </div>
                  <div :class="['col', !editForm ? 'col-10' : 'col-12']">
                    <label class="form-control-label">Filial<span class="text-danger"> *</span></label>
                    <ValidationProvider
                      vid="branch"
                      name="branch"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <base-input
                        :error="errors[0]"
                      >
                        <multiselect
                          v-model="branch"
                          :options="branches"
                          :filterable="true"
                          placeholder="Escolha uma filial"
                          @input="filterRegions"
                          track-by="id"
                          label="name"
                          :open-direction="'bottom'"
                        />
                      </base-input>
                    </ValidationProvider>
                  </div>
                  <div v-if="!editForm" class="col-2 col-sm-2 col-md-2" style="position: relative;">
                    <div class="new-button-wrapper">
                      <base-button type="secondary" @click="toggleBranch">Nova</base-button>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="row">
                  <div class="col-12 col-sm-12 col-md-12">
                    <ValidationProvider
                      vid="anosafra"
                      name="anosafra"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <base-input
                        :required="true"
                        :error="errors[0]"
                      >
                        <anosafra-multiselect
                          v-model="formData.branch.anosafras"
                          :multiple="true"
                          label="Anos Safras"
                          :limit="1"
                          :limit-text="limitText"
                          required="true"
                        />
                      </base-input>
                    </ValidationProvider>
                  </div>
                  <div class="col-md-5">
                    <label class="form-control-label">Unidade</label>
                    <ValidationProvider
                      vid="unity_id"
                      name="unity_id"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <base-input
                        :required="true"
                        :error="errors[0]"
                      >
                        <multiselect
                          v-model="formData.branch.unity_id"
                          :options="unities"
                          :filterable="true"
                          placeholder="Escolha uma unidade"
                          track-by="id"
                          label="description"
                        />
                      </base-input>
                    </ValidationProvider>
                  </div>
                  <div class="col-md-5">
                    <ValidationProvider
                      vid="branch"
                      name="branch"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <base-input
                        label="Nova Filial"
                        placeholder="Nome da Filial"
                        v-model="branchName"
                        name="branch"
                        rules="required"
                        :error="errors[0] || branchError"
                      />
                    </ValidationProvider>
                  </div>
                  <div class="col-md-2" style="position: relative;">
                    <div style="position: absolute; top: 32%;">
                      <base-button type="secondary" @click="toggleBranch">Existente</base-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-10 col-sm-10 col-md-12">
              <div v-if="formOptions.existingRegion">
                <div class="row">
                  <div :class="['col', !editForm ? 'col-10' : 'col-12']">
                    <label class="form-control-label">Região<span class="text-danger"> *</span></label>
                    <ValidationProvider vid="region" name="region" rules="required" v-slot="{ errors }">
                      <base-input v-if="!editForm" :required="true" :error="errors[0]">
                        <multiselect
                          v-model="selectedRegions"
                          :options="filteredRegions"
                          placeholder="Escolha uma Região"
                          label="name"
                          track-by="id"
                          :multiple="true"
                          :required="true"
                          :preserve-search="true"
                          :close-on-select="true"
                          :limit="1"
                          :limit-text="limitText"
                          :error="error[0]"
                          @input="checkBranchChange(selectedRegions)"
                          :open-direction="'bottom'"
                        >
                          <template slot="beforeList">
                            <div 
                              v-if="filteredRegions.length > 1"
                              @click="selectAllRegions"
                              :class="allRegionSelected ? 'all-selected' : 'multiple select-all-option'"
                              :style="allRegionSelected ? 'background-color: #e9ecef; color: #212529' : ''"
                            >
                              <span :style="allRegionSelected ? 'font-weight: 700' : ''">
                                {{ allRegionSelected ? 'Desmarcar todas' : 'Selecionar todas' }}
                              </span>
                            </div>
                          </template>
                        </multiselect>
                      </base-input>
                      <div v-for="option in selectedRegions" :key="option.id" v-if="editForm">
                        <base-input
                          name="region"
                          rules="required"
                          v-model="option.name"
                          :error="error[0] || regionError"
                        />
                      </div>
                    </ValidationProvider>
                  </div>
                  <div v-if="!editForm" class="col-2 col-sm-2 col-md-2" style="position: relative;">
                    <div class="new-button-wrapper">
                      <base-button type="secondary" @click="toggleRegion">Nova</base-button>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="row">
                  <div class="col-md-7">
                    <ValidationProvider
                      vid="region"
                      name="Nome da Região"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <base-input
                        label="Nova Região"
                        placeholder="Nome da Região"
                        v-model="regionName"
                        name="region"
                        :required="true"
                        :error="errors[0] || regionError"  
                        @input="addRegion"  
                      />
                    </ValidationProvider>
                  </div>
                  <div class="col-md-3">
                    <div style="margin-top: 42%;">
                      <base-slider
                        v-model="sliderValue"
                        :options="{tooltips: [true], range: {'min': 100, 'max': 100000}}"
                      ></base-slider>
                    </div>
                  </div>
                  <div class="col-md-2" style="position: relative;">
                    <div style="position: absolute; top: 32%;">
                      <base-button type="secondary" @click="toggleRegion">Existente</base-button>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <region-map
                      :marker="marker"
                      v-on:update:marker="setMarker"
                      :single="true"
                      :radius="parseFloat(sliderValue)"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-10 col-md-12">
              <div class="form-group" v-for="(selectedRegion, index) in selectedRegions" :key="index">
                <ValidationProvider
                  :vid="`sectors_${index}`"
                  name="sectors_attributes"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <base-input
                    :label="getSectorLabel(selectedRegion)"
                    placeholder="Nome do Setor"
                    v-model="sectors_attributes[index]"
                    :required="true"
                    :error="errors[0] || sectorError"
                    name="sector"
                  />
                  </ValidationProvider>
                </div>
            </div>
          </div>
        </form>
      </validation-observer>
      <template slot="footer">
        <base-button type="secondary" @click="modals.modal0 = false">Fechar</base-button>
        <base-button type="success" @click="save">Salvar</base-button>
      </template>
    </modal>
    <card>
      <div slot="header">
        <span>Setores</span>
      </div>
      <form>
        <div class="row">
          <div class="col-md-3">
            <div>
              <anosafra-multiselect
                v-model="filter.anosafra"
                label="Ano Safra"
                :multiple="true"
                :limit="1"
                :limit-text="limitText"
              />
            </div>
          </div>
          <div class="col-md-3">
            <div>
              <label class="form-control-label">Filial</label>
              <multiselect
                v-model="filter.branch"
                :options="branches"
                placeholder="Selecionar Filial"
                label="name"
                :selected-label="'Selecionado'"
                track-by="id"
                @input="filterRegions"
                :allow-empty="true"
              ></multiselect>
            </div>
          </div>
          <div class="col-md-3">
            <div>
              <label class="form-control-label">Região</label>
              <multiselect
                v-model="filter.region"
                :options="filteredRegions"
                placeholder="Selecionar região"
                label="name"
                :selected-label="'Selecionado'"
                track-by="id"
                :allow-empty="true"
              ></multiselect>
            </div>
          </div>
          <div class="col-md-3">
            <div>
              <base-input
                label="Setor"
                placeholder="Nome do Setor"
                v-model="filter['sectors.name']"
                class="base-input-style"
              />
            </div>
          </div>
          <div class="col-md-12 mb-4 d-flex justify-content-end">
            <base-button class="mr-2" type="neutral" @click="clearFilters">
              Limpar Pesquisa
            </base-button>
            <base-button type="primary" @click="search">
              Pesquisar
              <i class="fas fa-search"></i>
            </base-button>
          </div>
        </div>
      </form>
      <el-table
        v-loading="isLoading"
        class="table-responsive table-striped clickable-rows"
        header-row-class-name="thead-light"
        :data="sectors"
        ref="sectors"
      >
        <el-table-column label="Filial" min-width="200px" prop="region.branch.name" sortable></el-table-column>
        <el-table-column label="Regiões" min-width="150px" prop="region.name" sortable></el-table-column>
        <el-table-column label="Setor" min-width="160px" prop="name" sortable></el-table-column>
        <el-table-column label="Ação" min-width="130px" v-slot="{row}">
          <el-dropdown trigger="hover" class="dropdown" style="cursor: pointer;">
            <span class="btn btn-sm btn-icon-only text-success">
              <i class="fas fa-ellipsis-v mt-2"></i>
            </span>
            <el-dropdown-menu class="dropdown-menu dropdown-menu-arrow show" slot="dropdown">
              <a class="dropdown-item" @click="edit(row)">Editar</a>
              <a class="dropdown-item" @click="destroy(row)">Excluir</a>
            </el-dropdown-menu>
          </el-dropdown>
        </el-table-column>
      </el-table>
      <div slot="footer" class="py-4 d-flex justify-content-end">
        <base-pagination
          v-on:input="changePage"
          v-model="paginated_data['page']"
          :total="paginated_data['count']"
          :perPage="paginated_data['per_page']"
        ></base-pagination>
      </div>
    </card>
  </div>
</template>
<script>
  import { Select, Option, DropdownMenu, DropdownItem, Dropdown } from "element-ui";
  import { Table, TableColumn } from "element-ui";
  import PageTitle from "@/layouts/PageTitle";
  import Multiselect from "@/components/Multiselect/translated_multiselect.vue";
  import AnosafraMultiselect from "@/components/Multiselect/anosafra_multiselect.vue";

  import RegionMap from "./regionMap";
  import swal from 'sweetalert2';
  import 'sweetalert2/dist/sweetalert2.css';
  import { ValidationProvider, extend } from "vee-validate";
  import { required } from "vee-validate/dist/rules";
  extend("required", {
    ...required,
    message: "Este campo é obrigatório",
  });
  import BaseSlider from "@/components/BaseSlider";

  export default {
    name: "app",
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      PageTitle,
      Multiselect,
      AnosafraMultiselect,
      RegionMap,
      ValidationProvider,
      BaseSlider,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
    },
    data() {
      return {
        modals: {
          modal0: false,
        },
        error: '',
        errorMessages: [],
        filter: [
          {
            anosafra: null,
            region: null,
            branch: null,
            'sectors.name': ''
          }
        ],
        errors: [],
        sectors: [],
        sector_id: null,
        regions: [],
        unities: [],
        filteredRegions: [],
        branches: [],
        anosafraOptions: [],
        formOptions: {
          existingBranch: true,
          existingRegion: true,
        },
        allRegionSelected: false,
        editForm: false,
        filtered: false,
        paginated_data: [],
        branch: null,
        region: {},
        sectors_attributes: [],
        selectedRegions: null,
        branchName: null,
        regionName: '',
        formData: {
          branch: {
            unity_id: null,
            anosafras: []
          }
        },
        anosafra_sector_id: {},
        marker: {},
        isLoading: false,
        sliderValue: 4500,
      };
    },
    async created() {
      this.setStaticData();
      await this.setCurrentAonsafra();
      await this.search();
    },
    methods: {
      selectAllRegions() {
        if (this.allRegionSelected) {
          this.selectedRegions = [];
        } else {
          this.selectedRegions = [...this.filteredRegions];
        }
        this.allRegionSelected = !this.allRegionSelected;
      },
      addRegion() {
        this.selectedRegions = []
        if (this.regionName.trim() !== "") {
          this.selectedRegions.push({
            region_name: this.regionName
          });
        }
      },
      getSectorLabel(region) {
        if (!region) {
          return 'Setor';
        }

        let prefixLabel = this.sector_id ? "Editar" : "Novo";
        const regionName = region.region_name || region.name || '';
        return prefixLabel + ' Setor ' + (regionName.length > 0 ? regionName : '').toUpperCase();
      },
      limitText(count) { 
        return + count
      },
      restoreAnosafraOptions() {
        this.anosafraOptions = [...this.originalAnosafraOptions];
      },
      edit(sector) {
        this.selectedRegions = [sector.region];
        this.sectors_attributes[0] = sector.anosafra_sectors && sector.anosafra_sectors.length > 0
          ? sector.anosafra_sectors[0].sector_name 
          : sector.name;
        this.anosafra_sector_id = sector &&  sector.anosafra_sectors?  sector.anosafra_sectors.map(anosafraSector => anosafraSector.id) : null
        this.sector_id = sector.id;
        this.formData.branch.unity_id = sector.unity_id || null;
        this.branch = sector.region && sector.region.branch? sector.region.branch : null

        this.originalAnosafraOptions = [...this.anosafraOptions];
        
        const anosafraIds = sector && sector.anosafra_sectors ? sector.anosafra_sectors.map(anosafraSector => anosafraSector.anosafra_id) : [];
        
        this.formData.branch.anosafras = Array.from(new Set(anosafraIds))
          .map(uniqueId => this.anosafraOptions.find(option => option.id === uniqueId))
          .filter(option => option !== undefined);

        this.anosafraOptions = this.anosafraOptions.filter(option => 
          anosafraIds.includes(option.id)
        );
        
        this.modals.modal0 = true;
        this.editForm = true;
        this.formOptions.existingBranch = true;
        this.formOptions.existingRegion = true;
      },
      async destroy(sector) {
        try {
          await this.$http.secured.delete(`/api/v1/sectors/${sector.id}`);
          
          let index = this.sectors.findIndex(s => sector.id === s.id);
          if (index !== -1) {
            this.sectors.splice(index, 1);
          }

          this.$toasted.global.defaultSuccess();
        } catch (error) {
          this.$toasted.global.defaultError('Erro ao excluir o setor');
        }
      },
      rowClicked(row) {
        this.$refs.sectors.toggleRowExpansion(row);
      },
      filterRegions(value) {
        var objectValue = null;

        if (typeof value !== "object" && value !== null) {
          objectValue = this.regions.find((e) => e.id == value);
        } else {
          objectValue = value;
        }
        this.filteredRegions = this.regions.filter(
          (e) => e.branch_id == objectValue.id
        );
      },
      setError(error, text) {
        this.error =
          (error.response && error.response.data && error.response.data.error) ||
          text;
      },
      fetchSectors(q, page) {
        this.isLoading = true;
        if (typeof page === "undefined") page = null;
        if (typeof q === "undefined" || this.emptyFilter) q = null;

        this.$http.secured
          .get("/api/v1/sectors", {
            params: {
              page: page,
              q: q,
            },
          })
          .then((response) => {
            this.paginated_data = response.data;
            this.sectors = this.paginated_data.sectors
            this.isLoading = false;
          })
          .catch((error) => this.setError(error, "Something went wrong"));
      },
      setStaticData() {
        this.$http.secured
          .get("/api/v1/branches")
          .then((response) => {
            this.branches = response.data;
          })
          .catch((error) => this.setError(error, "failed to fetch branches"));

        this.$http.secured
          .get("/api/v1/regions")
          .then((response) => {
            this.regions = response.data;
            this.filteredRegions = this.regions
            })
          .catch((error) => this.setError(error, "Failed to fetch regions"));

        this.$http.secured
          .get("/api/v1/unities")
          .then((response) => {
            this.unities = response.data;
          })
          .catch((error) => this.setError(error, "Failed to fetch regions"));
      },
      toggleRegion() {
        this.selectedRegions = null
        this.formOptions.existingRegion = !this.formOptions.existingRegion;
        this.editForm = false;
      },
      toggleBranch() {
        this.branch = null
        this.formOptions.existingBranch = !this.formOptions.existingBranch;
        if (!this.formOptions.existingBranch) {
          this.filteredRegions = this.regions
        } else {
          this.filteredRegions = this.filterRegions(this.branch.id)
        }
      },
      async search() {
        const formattedFilter = this.formatFilter(this.filter);
        this.fetchSectors(formattedFilter);
      },
      formatFilter(filter) {
        const formatted = {};

        if (filter.branch) {
          formatted.branch_id = filter.branch.id;
        }

        if (filter.region) {
          formatted.region_id = filter.region.id;
        }

        if (filter.anosafra) {
          formatted.anosafra_id = filter.anosafra.map(a => a.id);
        }

        if (filter['sectors.name']) {
          formatted.name = filter['sectors.name'];
        }

        Object.keys(formatted).forEach(key => {
          if (
            formatted[key] === undefined || 
            formatted[key] === null || 
            (Array.isArray(formatted[key]) && formatted[key].length === 0) || 
            (typeof formatted[key] === 'string' && formatted[key].trim() === '')
          ) {
            delete formatted[key];
          }
        });

        return formatted;
      },
      changePage(page) {
        let filterInput = this.formatFilter(this.filter);
  
        this.fetchSectors(filterInput, page);
      },
      handleRequestSuccess() {
        const filterInput = this.filter ? this.formatFilter(this.filter) : null;
        this.fetchSectors(filterInput, this.paginated_data['page']);
        this.$toasted.global.defaultSuccess();
        this.modals.modal0 = false;
        this.resetInputs();
        this.$refs.observer.reset();
        this.restoreAnosafraOptions()
        this.setStaticData();
      },
      async save() {
        const validForm = await this.$refs.observer.validate();
        if (!validForm || !this.checkUnity) {
          return;
        }
        
        if (this.branch && this.branch.id) {
          return await this.updateRegionwhitheNewNBranch();
        }

        return await this.createBranch();
      },
      setMarker(value){
        this.marker = value
      },
      resetInputs() {
        this.allRegionSelected = false,
        this.formOptions.existingBranch = true,
        this.formOptions.existingRegion = true,
        this.regionName = '',
        this.sector_id = null
        this.anosafra_sector_id = null
        this.branchName = null;
        this.selectedRegions = null;
        this.sectors_attributes = [],
        this.formData = {
          branch: {
            regions_attributes: [
              { 
                region_name: '',
                region_position_attributes: {},
              },
            ],
          },
        };
        this.marker = {};
        this.errorMessages = []
        this.editForm = false;
        this.restoreAnosafraOptions()
      },
      register() {
        this.branch = ''
        this.sector_id  = null
        this.sectors_attributes = []
        this.selectedRegions = null
        this.formData = {
          branch: {
            regions_attributes: [
              {
                region_position_attributes: {},
              },
            ],
          },
        };
        this.allRegionSelected = false,
        this.modals.modal0 = true;

        const currentAnosafra = this.$store.state.currentAnosafra;
        const selectedAnosafra = this.anosafraOptions.find(
          (anosafra) => anosafra.id === currentAnosafra.id
        );
        this.$set(this.formData.branch, 'anosafras', selectedAnosafra ? [selectedAnosafra] : null);
      },
      checkUnity(){
        if(!this.formData.branch.unity_id && !this.formOptions.existingBranch ){
          return false;
        }
        return true;
      },
      checkBranchChange(selectedRegion) {
        if (!this.branch) return null;
        if (selectedRegion.branch_id !== this.branch.id) return null;

        swal.fire({
          title: 'Tem Certeza?',
          text: "A região será associada à nova Filial!",
          icon: 'warning',
          showCancelButton: true,
          cancelButtonText: 'Cancelar',
          confirmButtonText: 'Tenho Certeza!'
        }).then((result) => {
          if (result.dismiss === swal.DismissReason.cancel) {
            this.selectedRegions = null;
          }
        });
      },
      async updateRegionwhitheNewNBranch() {
        const regionsToUpdate = this.selectedRegions.filter(region => region.branch_id !== this.branch.id)

        const isRegionNew = this.selectedRegions[0].id == null;

        if (regionsToUpdate.length === 0 || isRegionNew) { 
          return await this.updateBranch()
        }

        const existingRegionIds = this.branch && this.branch.region_ids ? this.branch.region_ids : [];
        
        const allRegionIds = [
          ...new Set([
            ...regionsToUpdate.map(region => region.id),
            ...existingRegionIds
          ])
        ];

        try {
           await this.$http.secured.put(`/api/v1/branches/${this.branch.id}`, { 
            branch: {
              region_ids: allRegionIds,
            } 
          });

          await this.updateBranch();
        } catch (error) {
          console.error("Erro ao vincular regiões ao branch ", error);
        }
      },
      async createBranch() {
        const formatedBranch = {
          branch: {
            unity_id: this.formData.branch.unity_id,
            name: this.branchName,
            region_ids: this.selectedRegions.map(region => region.id),
            anosafra_branches_attributes: this.formData.branch.anosafras.map(anosafra => ({
              anosafra_id: anosafra.id,
              branch_name: this.branchName,
            })),
            regions_attributes: this.selectedRegions.map((region, regionIndex) => ({
              name: region.region_name || region.name,
              anosafra_regions_attributes: this.formData.branch.anosafras.map((anosafra) => {
                const anosafraRegions = region.anosafra_regions
                  ? region.anosafra_regions.find(anosafraRegion => anosafraRegion.anosafra_id === anosafra.id)
                  : null;

                return {
                  anosafra_id: anosafra.id,
                  id: anosafraRegions ? anosafraRegions.id : null,
                  region_name: region.region_name || region.name,
                };
              }),
              sectors_attributes: [
                {
                  region_id: region.id,
                  name: this.sectors_attributes[regionIndex],
                  anosafra_sectors_attributes: this.formData.branch.anosafras.map((anosafra, index) => ({
                    id: this.anosafra_sector_id ? this.anosafra_sector_id[index] : null,
                    anosafra_id: anosafra.id,
                    region_id: region.id,
                    sector_name: this.sectors_attributes[regionIndex],
                  })),
                }
              ],
            })),
          },
        };

        try {
          await this.$http.secured.post("/api/v1/branches", formatedBranch)
          this.handleRequestSuccess()
        } catch (error) {
          let errors = (error.response && error.response.data && error.response.data.errors)
          this.$set(this, 'errorMessages', errors);
          throw error;
        }
      },
      async updateBranch() {
        const anosafras = this.formData.branch.anosafras.filter(el => 
          !this.branch.anosafra_ids.includes(el.id)
        );

        const formatedBranch = {
          branch: {
            id: this.branch.id,
            anosafra_branches_attributes: anosafras.map(anosafra => ({
              anosafra_id: anosafra.id,
              branch_id: this.branch.id,
            })),
            regions_attributes: this.selectedRegions.map((region, regionIndex) => ({
              id: this.branch.id? region.id : null,
              name: region.region_name || region.name,
              anosafra_regions_attributes: region.anosafra_regions ?  
                region.anosafra_regions.map(anosafraRegion => ({
                  anosafra_id: anosafraRegion.anosafra_id,
                  id: anosafraRegion.id,
                  region_name: region.region_name || region.name
                })) : 
                null,
              sectors_attributes: [{
                region_id: region.id,
                id: this.sector_id,
                name: this.sectors_attributes[regionIndex],
                anosafra_sectors_attributes: this.formData.branch.anosafras.map((anosafra, index) => ({
                  id: this.anosafra_sector_id ? this.anosafra_sector_id[index] : null,
                  sector_id: this.sector_id,
                  anosafra_id: anosafra.id,
                  sector_name: this.sectors_attributes[regionIndex],
                })),
              }],
            })),
          },
        };

        try {
          const response = await this.$http.secured.put(`/api/v1/branches/${this.branch.id}`, formatedBranch);
          if (response.status === 200) this.handleRequestSuccess();
        } catch (error) {
          let errors = (error.response && error.response.data && error.response.data.errors)
          this.$set(this, 'errorMessages', errors);
          throw error;
        }
      },
      clearFilters() {
        this.filter.branch = null;
        this.filter.region = null;
        this.filter.anosafra = null;
        this.filter['sectors.name'] = '';
        this.setStaticData();
        this.fetchSectors();
      },
      async setCurrentAonsafra() {
        const currentAnosafra = this.$store.state.currentAnosafra;
        const selectedAnosafra = this.anosafraOptions.find(
          (anosafra) => anosafra.id === currentAnosafra.id
        );
        this.$set(this.filter, 'anosafra', selectedAnosafra ? [selectedAnosafra] : null);
      }
    },
    computed: {
      branchError() {
        return this.errorMessages.some(el => 
          el.match(/branch(.+?)\sjá\sexiste/) || el.match(/Nome já existe/)
        ) ? "Nome da filial já existe" : null;
      },
      sectorError() {
        const sectorError = this.errorMessages.find(el => 
          el.match(/sector.+Já existe/i)
        );

        return sectorError 
          ? sectorError.match(/Já existe.+/i)[0] 
          : null;
      },
      regionError() {
        return this.errorMessages.some(el => 
          el.match(/anosafra regions region name já existe/i) || 
          el.match(/regions?(.+?)\sjá\sexiste/i) &&
          !el.match(/setor|sector/i)
        ) ? "Nome da região já existe" : null;
      }
    },
    watch: {
      'branch': function(newBranch) {
        if (!newBranch) {
          this.filteredRegions = this.regions;
        } else {
          this.filterRegions(newBranch);
        }
      },
      'modals.modal0'(newValue) {
        if (!newValue) {
          this.resetInputs();
        } 
      },
      'formData.branch.anosafras': {
        handler(selected) {
          if (!selected) return;

          this.allAnosafraselected = selected.length === this.anosafraOptions.length;
        },
        immediate: true,
      },
      selectedRegions: {
        handler(selected) {
          if (!selected) return;
          
          this.allRegionsSelected = selected.length === this.filteredRegions.length;
        },
        immediate: true,
      },
    }
  };
</script>

<style scoped>
.multiple, .all-selected {
  cursor: pointer;
  box-shadow: none;
  height: 40px;
  padding: 8px 10px;
  display: flex;
  align-items: center;
}

.multiple:hover, .all-selected:hover {
  background-color: #41b883;
  color: white;
}

.multiselect__option--highlight {
  background-color: transparent !important;
  color: #35495e;
}

.multiselect__option:hover, .all-selected:hover {
  background-color: #41b883 !important;
  color: white;
}

.multiselect__option--selected.multiselect__option--highlight {
  background-color: rgb(239, 241, 244) !important;
  color: #35495e;
}

.base-input-style{
  input.form-control{
    max-height: 40px;
  }
}

.new-button-wrapper {
  position: absolute;
  top: 30px;
}

.multiselect__content-wrapper {
  max-height: 200px !important;
  overflow-y: auto !important;
  position: relative !important;
}

.multiselect--above .multiselect__content-wrapper {
  top: auto !important;
  bottom: 100% !important;
}

.error-message {
  color: #FF6347;
  font-size: 12px;
}
</style>

